import * as signalR from "@aspnet/signalr";
import config from "../config";

// SignalR 连接状态枚举
export const ConnectionState = {
    DISCONNECTED: 0, // 已断开
    CONNECTING: 1, // 正在连接
    CONNECTED: 2, // 已连接
    DISCONNECTING: 3, // 正在断开
};

// 状态映射函数
export const getStateName = (state) => {
    switch (state) {
        case ConnectionState.DISCONNECTED:
            return "Disconnected";
        case ConnectionState.CONNECTING:
            return "Connecting";
        case ConnectionState.CONNECTED:
            return "Connected";
        case ConnectionState.DISCONNECTING:
            return "Disconnecting";
        default:
            return "Unknown";
    }
};

// 获取当前环境的 API 基础 URL
const getApiBaseUrl = () => {
    return config.baseUrl[config.appEnv];
};

const hub = new signalR.HubConnectionBuilder()
    .withUrl(getApiBaseUrl() + "/hub/dataChange", {
        withCredentials: false,
    })
    .configureLogging(signalR.LogLevel.Information)
    .build();

// 自动重连逻辑
let reconnectTimeout = null;
let reconnectAttempts = 0;
const maxReconnectAttempts = 10;
const baseReconnectDelay = 2000;

function start() {
    // 防止重复启动连接
    if (hub.state !== ConnectionState.DISCONNECTED) {
        console.warn("SignalR 连接已处于活动状态，当前状态:", hub.state);
        return Promise.resolve();
    }

    console.log("启动 SignalR 连接，当前状态:", hub.state);
    return hub
        .start()
        .then(() => {
            console.log("SignalR 连接成功，状态:", hub.state);
            reconnectAttempts = 0;
        })
        .catch((err) => {
            console.error("SignalR 连接失败，状态:", hub.state, err);
            scheduleReconnect();
            throw err;
        });
}

function scheduleReconnect() {
    if (reconnectAttempts >= maxReconnectAttempts) {
        console.error("SignalR 重连次数已达上限，停止重连");
        return;
    }

    reconnectAttempts++;
    const delay = baseReconnectDelay * Math.pow(2, reconnectAttempts - 1);
    console.log(
        `SignalR 将在 ${delay}ms 后进行第 ${reconnectAttempts} 次重连尝试`,
    );

    reconnectTimeout = setTimeout(() => {
        start();
    }, delay);
}

// 启动连接将在组件中手动管理

// 添加连接状态管理 - 返回状态名称和枚举值
hub.getConnectionState = function () {
    return hub.state;
};

// 将状态名称转换为枚举值
function getStateEnumValue(stateName) {
    switch (stateName) {
        case "Disconnected":
            return ConnectionState.DISCONNECTED;
        case "Connecting":
            return ConnectionState.CONNECTING;
        case "Connected":
            return ConnectionState.CONNECTED;
        case "Disconnecting":
            return ConnectionState.DISCONNECTING;
        default:
            return ConnectionState.DISCONNECTED;
    }
}

// 监听连接状态变化 - 兼容 @aspnet/signalr 1.1.4 版本
hub.onclose(() => {
    console.log("SignalR 连接已关闭，状态:", hub.state);
    scheduleReconnect();
});

// 注意：@aspnet/signalr 1.1.4 版本不支持 onreconnecting 和 onreconnected 事件
// 重连逻辑通过 onclose 事件和 scheduleReconnect 函数处理

export default hub;



// WEBPACK FOOTER //
// ./src/libs/signalr.js